// extracted by mini-css-extract-plugin
export default {"input":"StyledInput_input__8J-uu","disabled":"StyledInput_disabled__+9zoq"};